import $ from 'jquery';

function init() {
  const scrollToTopBtn = document.querySelector('.scroll-to-top');
  const rootElement = document.documentElement;

  $(window).scroll(function() {
    let firstElement = $('main > :first-child + *').outerHeight(true);
    if ($(window).scrollTop() > (firstElement / 2) ) {
      scrollToTopBtn.classList.add('scroll-to-top--visible');
    } else {
      scrollToTopBtn.classList.remove('scroll-to-top--visible');
    }

  })

  function scrollToTop() {
    rootElement.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  }

  scrollToTopBtn.addEventListener('click', scrollToTop);
}

// -------------------------------------------------------------------------------------------------
// Export
// -------------------------------------------------------------------------------------------------

export default {
  init,
};

